var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPauseDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    fill: "#7a7d7a",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8,0H28.2c-6.4,0-11.5,5.2-11.5,11.5v176.9c0,6.4,5.2,11.5,11.5,11.5h18.6c6.4,0,11.5-5.2,11.5-11.5V11.5 C58.4,5.2,53.2,0,46.8,0z M171.8,0h-18.6c-6.4,0-11.5,5.2-11.5,11.5v176.9c0,6.4,5.2,11.5,11.5,11.5h18.6c6.4,0,11.5-5.2,11.5-11.5 V11.5C183.3,5.2,178.1,0,171.8,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPauseDisabled);
export default __webpack_public_path__ + "static/media/ico-pauseDisabled.76ddc60cec75a79f54f47907e9bb9865.svg";
export { ForwardRef as ReactComponent };